import React from "react";
import {
  UxBreadcrumbs,
  UxElementTypeEnum,
  UxIconEnum
} from "@wne-spa/ux-component-library";
import { connect } from "react-redux";
import { IList, BreadCrumsProps } from "./IList";
import { useNavigate } from "react-router-dom";
import { updateBreadCrumbs, updateTabName, updateReportCard } from "../../Redux/Action";
import ReduxProps from "../../Redux/Redux.props";

interface Props extends ReduxProps, BreadCrumsProps {}

function mapStateToProps(state: ReduxProps) {
  return {
    getHeaderData: state.getHeaderData,
    getBreadCrumbsData: state.getBreadCrumbsData,
    getActivityIndicator: state.getActivityIndicator,
    getTabName: state.getTabName
  };
}

const Breadcrumbs = (props: Props) => {
  const { getBreadCrumbsData, getActivityIndicator, dispatch, getTabName } = props;
  const navigate = useNavigate();
  const handleClick = (path: string) => {
    if (getTabName === "ReportsTab" || getTabName === "reports") {
      dispatch(updateTabName(null));
    }
    if (path.includes("institutions")) {
      dispatch(updateTabName("schools"));
      localStorage.setItem("page", "schools");
    }
    const index = getBreadCrumbsData.crumbs.findIndex((data: IList) => data.path === path);
    //@ts-ignore
    const crumbs = getBreadCrumbsData;
    const newArray = crumbs.crumbs.filter((_item: IList, i: number) => {
      return i <= index;
    });
    localStorage.setItem("micro:crumbs", JSON.stringify(newArray));
    dispatch(updateBreadCrumbs({ crumbs: newArray }));
    navigate(path);
  };

  function reportsClick(name: string) {
    if (name.toLowerCase() === "reports") {
      dispatch(updateReportCard("home"));
    }
  }

  return (
    <>
      <UxBreadcrumbs
        separator={{ icon: UxIconEnum.CHEVRON_RIGHT }}
        elementType={UxElementTypeEnum.H1}
        children={getBreadCrumbsData.crumbs.map((path: IList) => ({
          title: path.name,
          callback: () => {
            handleClick(path.path);
            reportsClick(path.name);
          },
          loading: getActivityIndicator
        }))}
      />
    </>
  );
};

export default connect(mapStateToProps)(Breadcrumbs);
